import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { createLogger } from 'browser-bunyan';
import { ServerStream } from '@browser-bunyan/server-stream';
import { ServerLoggerConfig } from '~shared/modules/server-logger/models/server-logger-config.interface';
import { ServerLoggerConfigToken } from '~shared/modules/server-logger/tokens/server-logger.token';
import { isPlatformBrowser } from '@angular/common';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { FeatureToggleEnum } from '~shared/constants';

@Injectable()
export class ServerLoggerService {
  private logger = {
    //initialize empty func before hand just in case if its getting invoked before actual logger initialization
    debug: (...args) => {},
    info: (...args) => {},
    warn: (...args) => {},
    error: (...args) => {},
  };
  private serverStream;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(ServerLoggerConfigToken) private readonly serverLoggerConfig: ServerLoggerConfig,
    private readonly featureFlagService: ActiveFeaturesConfigcatService
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.featureFlagService
        .isFeatureEnabled(FeatureToggleEnum.FF_CHECKOUT_INCIDENT_FROZEN_REVIEW_PAGE)
        .subscribe((isFeatureEnabled) => {
          if (isFeatureEnabled) {
            if (isPlatformBrowser(this.platformId)) {
              this.serverStream = new ServerStream({
                url: serverLoggerConfig.logEndpoint,
                method: serverLoggerConfig.httpMethod,
                throttleInterval: 200,
                flushOnClose: true,
              });

              this.logger = createLogger({
                name: 'serverLogger',
                level: serverLoggerConfig.logLevel,
                stream: this.serverStream,
              });

              if (typeof window !== 'undefined') {
                window.addEventListener('beforeunload', () => {
                  this.flushLogs();
                });
              }
            }
          } else {
            this.logger = createLogger({
              name: 'serverLogger',
              level: serverLoggerConfig.logLevel,
              stream: new ServerStream({
                url: serverLoggerConfig.logEndpoint,
                method: serverLoggerConfig.httpMethod,
              }),
            });
          }
        });
    }
  }

  public debug(message: string, context: object = null) {
    this.logger.debug({ context }, message);
  }

  public info(message: string, context: object = null) {
    this.logger.info({ context }, message);
  }

  public warning(message: string, context: object = null) {
    this.logger.warn({ context }, message);
  }

  public error(message: string, context: object = null) {
    this.logger.error({ context }, message);
  }

  private flushLogs() {
    if (this.serverStream) {
      const records = this.serverStream.recordsAsArray();
      if (records && records.length > 0) {
        const xhr = new XMLHttpRequest();
        xhr.open(this.serverLoggerConfig.httpMethod, this.serverLoggerConfig.logEndpoint, false);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(records));

        this.serverStream.stop();
        this.serverStream.start({
          url: this.serverLoggerConfig.logEndpoint,
          method: this.serverLoggerConfig.httpMethod,
          throttleInterval: 0,
          flushOnClose: true,
        });
      }
    }
  }
}
